import React, { Component } from 'react';
import { COLORS } from '../../utils/constants';
import * as Parse from '../../utils/parsers';
import * as Format from '../../utils/formatters';
import SidebarMenuRouters from '../../routers/routers';
import Header from '../../containers/header';
import SimpleMonthPicker from '../../components/ui-components/SimpleMonthPicker';
import NewBusinessTable from '../../components/tables/newBusiness';
import ContractsIndicators from '../../components/contractsIndicator';
import VisitsNewBusiness from '../../charts/visitsNewBusiness';


export const BoxSingle = (props) => {

  return (
    <div className="iconbox-single" style={{height: '80%', minWidth: '50%', marginBottom: '0', marginRight: '0' +
        ''}}>
      <div className="box-title">
        <div>
          <h5 style={{color: COLORS.SUMMARY_GREEN}}>{props.title}</h5>
          <p style={{color: COLORS.SUMMARY_GRAY}}>{props.subtitle}</p>
        </div>
      </div>
      <div className="chart">
        {props.children}
      </div>
    </div>
  )
};


class NewBusiness extends Component{
  constructor(props) {
    super(props);
    let userData = JSON.parse(localStorage.getItem('userData'));
    let today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth()+1;
    let dateModal = Format.formatStringMonth(month.toString())+' '+year;
    this.state={ userData: userData, dateModal: dateModal, year: year, month: month }
  }

  callback = (dataFromChild) => {
    let date = Parse.toCustomDateLastDay(dataFromChild);
    let year = Parse.toGetYear(date);
    let month = Parse.toGetMonth(date);
    let dateModal = Format.formatStringMonth(month)+' '+year;
    this.setState({year: year, month: month, dateModal: dateModal, dateModalNumber:dataFromChild.getMonth()+1, key: Math.random() });
  };

  render() {

    const authorization= (this.state.userData.name === 'Area comercial' || this.state.userData.account === 'mcgh@estrategas.mx' || this.state.userData.account === 'lmnr@estrategas.mx');

    return (
      <div>
        <SidebarMenuRouters profile="/direction-home/" place={''}/>
        <Header userName={this.state.userData.name} title={'Nuevos negocios'}/>
        <div className={'row'}>
          <div className='col-lg-9 col-md-8 col-sm-7 col-5 header-quality text-center'>
            <p>Nuevos negocios</p>
          </div>
          <div className={'col-lg-3 col-md-4 col-sm-5 col-7'}>
            <BoxSingle
              title={<SimpleMonthPicker callbackFromParent={this.callback}/>}
              subtitle="Periodo"
            >
            </BoxSingle>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0 '}>
            <ContractsIndicators key={this.state.key} year={this.state.year} month={this.state.month} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0 '}>
            <NewBusinessTable key={this.state.key} year={this.state.year} month={this.state.month} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0 '}>
            <VisitsNewBusiness key={this.state.key} year={this.state.year} month={this.state.month} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
      </div>
    );
  }
}

export default NewBusiness;



// WEBPACK FOOTER //
// ./src/scene/new-business/newBusiness.js